<template>
  <div class="flex-item custom-menu">
    <ur-gnb
      v-if="top_menu.length"
      class="gnb-showcase"
      :top-menu="top_menu"
      @move="move"
      :selected-menu="getSelectedMenu"
    >
      <template slot="title">
        <div class="for-desktop">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="112.374"
            height="17.178"
            viewBox="0 0 112.374 17.178"
          >
            <g
              id="Group_3228"
              data-name="Group 3228"
              transform="translate(-22.324 -15.473)"
            >
              <path
                id="Path_8167"
                data-name="Path 8167"
                d="M.588,0h2.87a5.061,5.061,0,0,0,5.32-5.11c0-2.9-1.96-5.11-5.4-5.11H.588ZM3.15-8.456c2.52,0,3.724,1.386,3.724,3.346a3.342,3.342,0,0,1-3.64,3.346H2.492V-8.456ZM9.52,0h1.9V-7.1L14.49-2.94l3.136-4.228V0h1.9V-10.22H17.724l-3.22,4.3-3.094-4.3H9.52ZM24,.14a3.277,3.277,0,0,0,3.528-3.178c0-1.96-1.568-2.576-2.954-3.024-1.106-.364-2.086-.63-2.086-1.442,0-.658.5-1.162,1.428-1.162a2.1,2.1,0,0,1,1.848.98l1.568-1.19A4.369,4.369,0,0,0,23.9-10.36,3.114,3.114,0,0,0,20.51-7.434c0,1.946,1.526,2.478,2.9,2.912,1.092.336,2.128.6,2.128,1.47A1.408,1.408,0,0,1,23.982-1.68a2.578,2.578,0,0,1-2.24-1.386L20.006-1.694A5.028,5.028,0,0,0,24,.14Zm12.558,0a5.2,5.2,0,0,0,4.634-2.912l-1.736-.91a3.179,3.179,0,0,1-2.94,1.918A3.279,3.279,0,0,1,33.194-5.11a3.3,3.3,0,0,1,3.36-3.374,3.059,3.059,0,0,1,2.814,1.722l1.666-1.064a5.163,5.163,0,0,0-4.48-2.534A5.123,5.123,0,0,0,31.3-5.11,5.09,5.09,0,0,0,36.554.14ZM45.78.168a4.233,4.233,0,0,0,4.242-4.256,4.236,4.236,0,0,0-4.242-4.27,4.228,4.228,0,0,0-4.242,4.27A4.224,4.224,0,0,0,45.78.168Zm0-1.778A2.409,2.409,0,0,1,43.4-4.088,2.413,2.413,0,0,1,45.78-6.58a2.431,2.431,0,0,1,2.38,2.492A2.427,2.427,0,0,1,45.78-1.61ZM50.708,0H52.6V-4.494A1.963,1.963,0,0,1,54.516-6.72c1.232,0,1.848.8,1.848,2.058V0h1.918V-4.858c0-2.184-1.232-3.5-3.248-3.5a3.014,3.014,0,0,0-2.45,1.176V-8.19H50.708Zm8.526,0h1.89V-4.494A1.963,1.963,0,0,1,63.042-6.72c1.232,0,1.848.8,1.848,2.058V0h1.918V-4.858c0-2.184-1.232-3.5-3.248-3.5a3.014,3.014,0,0,0-2.45,1.176V-8.19H59.234ZM71.82.168a4.149,4.149,0,0,0,3.822-2.212l-1.554-.9A2.42,2.42,0,0,1,71.82-1.5,2.426,2.426,0,0,1,69.3-3.43h6.664v-.714A4.09,4.09,0,0,0,71.75-8.358a4.225,4.225,0,0,0-4.256,4.284A4.157,4.157,0,0,0,71.82.168Zm-.07-6.86a2.177,2.177,0,0,1,2.3,1.68H69.4A2.426,2.426,0,0,1,71.75-6.692Zm8.9,6.86a4.132,4.132,0,0,0,3.934-2.576l-1.694-.728A2.366,2.366,0,0,1,80.682-1.61a2.429,2.429,0,0,1-2.436-2.478A2.421,2.421,0,0,1,80.668-6.58a2.348,2.348,0,0,1,2.2,1.47l1.694-.714a4.156,4.156,0,0,0-3.906-2.534A4.222,4.222,0,0,0,76.4-4.088,4.228,4.228,0,0,0,80.654.168ZM84.728-6.5h1.4v3.08c0,2.6.77,3.416,3.3,3.416H89.7V-1.778c-1.47,0-1.666-.224-1.666-1.652V-6.5H89.7V-8.19H88.032v-2.548l-1.9,1.3V-8.19h-1.4Z"
                transform="translate(45 30)"
                fill="#454ca5"
              />
              <g
                id="Group_3224"
                data-name="Group 3224"
                transform="translate(22.324 15.473)"
              >
                <path
                  id="Path_8110"
                  data-name="Path 8110"
                  d="M351.1,223.474q0-2.406,0-4.812a1.233,1.233,0,0,0-1.341-1.332c-.716,0-1.431,0-2.147,0-.142,0-.2.024-.2.185q.014,1.045,0,2.089c0,.16.054.191.2.185.23-.01.46-.006.69,0a.309.309,0,0,1,.343.345q0,3.336,0,6.671a.308.308,0,0,1-.345.343q-3.335,0-6.671,0a.306.306,0,0,1-.342-.346q0-3.336,0-6.671a.309.309,0,0,1,.346-.343c.249,0,.5,0,.748,0,.1,0,.134-.026.134-.129q-.005-1.1,0-2.2c0-.089-.027-.123-.12-.123-.811,0-1.623-.016-2.434.011a1.194,1.194,0,0,0-1.125,1.192q-.006,4.927,0,9.853a1.211,1.211,0,0,0,1.207,1.213q4.926.006,9.853,0a1.213,1.213,0,0,0,1.205-1.234C351.1,226.733,351.1,225.1,351.1,223.474Z"
                  transform="translate(-333.925 -212.422)"
                  fill="#989ee6"
                />
                <path
                  id="Path_8111"
                  data-name="Path 8111"
                  d="M472.883,345.21h-4.792a1.231,1.231,0,0,0-1.323,1.329q0,4.821,0,9.642a1.228,1.228,0,0,0,1.3,1.3c.735,0,1.469,0,2.2,0,.135,0,.185-.022.183-.173-.009-.709-.007-1.418,0-2.128,0-.125-.032-.164-.158-.159-.242.01-.485.006-.728,0a.308.308,0,0,1-.342-.345q0-3.335,0-6.671a.308.308,0,0,1,.344-.344q3.335,0,6.67,0a.307.307,0,0,1,.345.342q0,3.335,0,6.67c0,.233-.12.345-.36.347s-.5,0-.747,0c-.091,0-.12.026-.12.118q0,1.112,0,2.223c0,.1.037.115.123.115.8,0,1.61.012,2.415-.008a1.2,1.2,0,0,0,1.142-1.234c0-1.412,0-2.824,0-4.236q0-2.722,0-5.444a1.234,1.234,0,0,0-1.343-1.349Z"
                  transform="translate(-466.768 -345.21)"
                  fill="#454ca5"
                />
              </g>
            </g>
          </svg>
        </div>
        <div class="for-mobile">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="50"
            height="20"
            viewBox="0 0 50 17"
          >
            <g
              id="Group_3228"
              data-name="Group 3228"
              transform="translate(-22.324 -15.473)"
            >
              <g
                id="Group_3224"
                data-name="Group 3224"
                transform="translate(22.324 15.473)"
              >
                <path
                  id="Path_8110"
                  data-name="Path 8110"
                  d="M351.1,223.474q0-2.406,0-4.812a1.233,1.233,0,0,0-1.341-1.332c-.716,0-1.431,0-2.147,0-.142,0-.2.024-.2.185q.014,1.045,0,2.089c0,.16.054.191.2.185.23-.01.46-.006.69,0a.309.309,0,0,1,.343.345q0,3.336,0,6.671a.308.308,0,0,1-.345.343q-3.335,0-6.671,0a.306.306,0,0,1-.342-.346q0-3.336,0-6.671a.309.309,0,0,1,.346-.343c.249,0,.5,0,.748,0,.1,0,.134-.026.134-.129q-.005-1.1,0-2.2c0-.089-.027-.123-.12-.123-.811,0-1.623-.016-2.434.011a1.194,1.194,0,0,0-1.125,1.192q-.006,4.927,0,9.853a1.211,1.211,0,0,0,1.207,1.213q4.926.006,9.853,0a1.213,1.213,0,0,0,1.205-1.234C351.1,226.733,351.1,225.1,351.1,223.474Z"
                  transform="translate(-333.925 -212.422)"
                  fill="#989ee6"
                />
                <path
                  id="Path_8111"
                  data-name="Path 8111"
                  d="M472.883,345.21h-4.792a1.231,1.231,0,0,0-1.323,1.329q0,4.821,0,9.642a1.228,1.228,0,0,0,1.3,1.3c.735,0,1.469,0,2.2,0,.135,0,.185-.022.183-.173-.009-.709-.007-1.418,0-2.128,0-.125-.032-.164-.158-.159-.242.01-.485.006-.728,0a.308.308,0,0,1-.342-.345q0-3.335,0-6.671a.308.308,0,0,1,.344-.344q3.335,0,6.67,0a.307.307,0,0,1,.345.342q0,3.335,0,6.67c0,.233-.12.345-.36.347s-.5,0-.747,0c-.091,0-.12.026-.12.118q0,1.112,0,2.223c0,.1.037.115.123.115.8,0,1.61.012,2.415-.008a1.2,1.2,0,0,0,1.142-1.234c0-1.412,0-2.824,0-4.236q0-2.722,0-5.444a1.234,1.234,0,0,0-1.343-1.349Z"
                  transform="translate(-466.768 -345.21)"
                  fill="#454ca5"
                />
              </g>
            </g>
          </svg>
        </div>
      </template>
      <template slot="action">
        <div id="burger-menu2">
          <svg
            data-v-73da1b8a=""
            id="setting"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="26"
          >
            <circle
              data-v-73da1b8a=""
              cx="12"
              cy="10"
              r="3"
              fill="#454ca5"
            ></circle>
            <circle
              data-v-73da1b8a=""
              cx="12"
              cy="12"
              r="9"
              stroke="#454ca5"
              stroke-width="1"
            ></circle>
            <path
              data-v-73da1b8a=""
              d="M17.8719 18.8083C17.9489 18.7468 17.9799 18.6436 17.9452 18.5513C17.5693 17.5518 16.8134 16.6706 15.7814 16.0332C14.6966 15.3632 13.3674 15 12 15C10.6326 15 9.30341 15.3632 8.21858 16.0332C7.18663 16.6706 6.43066 17.5518 6.05477 18.5513C6.02009 18.6436 6.05115 18.7468 6.12813 18.8083C9.56196 21.552 14.438 21.552 17.8719 18.8083Z"
              fill="#989ee6"
              fill-opacity="0.24"
              stroke="#454ca5"
              stroke-width="1"
              stroke-linecap="round"
            ></path>
          </svg>
        </div>
        <div id="forSettingMenu">
          <div
            data-v-73da1b8a=""
            class="user-dropdown top-header-dropdown custom-select"
          >
            <ur-dropdown
              v-model="selectedBusinessUnit"
              :items="businessUnitData"
              @input="inputBizUnit"
            />
            <!-- 
            @input="changeBusinessUnit" -->
            <!---->
          </div>
          <span class="for-desktop">
            <span class="horizontal-menus">
              <span id="open-help">
                <ur-icon-button
                  icon="help"
                  icon-type="line"
                  color="default"
                  v-ur-tooltip="'Help'"
                  iconSize="18"
                  class="mx-1"
                ></ur-icon-button>
              </span>
              <!---->
              <div id="overlay-Help"></div>
              <div id="sidebarMenu" class="openHelp">
                <div class="help-modal">
                  <div class="help-modal-header">
                    <div class="heading">
                      <h4>Heading</h4>
                      <span>Sub Heading</span>
                    </div>

                    <ur-icon-button
                      icon="close"
                      icon-type="line"
                      color="default"
                      id="close-help"
                      iconSize="18"
                      class="mx-1"
                    ></ur-icon-button>
                  </div>

                  <div class="help-modal-body">
                    <div class="inner-content">
                      <h4>Hey! Welcome to Sales Order Screen</h4>
                      <p>Navigate to Sales > Sales Order Creation</p>
                      <p>Below are few step for better understanding</p>

                      <ol class="ol-main-tree">
                        <li>
                          <h4>Click on Sold to Code</h4>
                          <p>
                            Fill all details Sold to Code, sold to name, name of
                            the Owner, Address, dropdown for city and PIN
                          </p>
                        </li>

                        <li>
                          <h4>
                            Request ID is to view' edit old partner requests.
                          </h4>
                          <p>
                            Fill all details Sold to Code, sold to name, name of
                            the Owner, Address, dropdown for city and PIN
                          </p>
                        </li>

                        <li>
                          <h4>Contact Details Section</h4>
                          <p>
                            Fill all details Sold to Code, sold to name, name of
                            the Owner, Address, dropdown for city and PIN
                          </p>
                        </li>
                      </ol>
                    </div>
                  </div>
                  <div class="help-modal-footer">
                    <div class="left-buttons">
                      <ur-button shape="solid" class="actn-cmmn-btn">
                        <ur-icon size="xsmall" class="mr-2">refresh</ur-icon>
                        Restart</ur-button
                      >
                    </div>
                    <div class="right-buttons">
                      <ur-button shape="solid" class="actn-cmmn-btn"
                        >Back</ur-button
                      >
                      <ur-button shape="solid" class="actn-nxt-btn"
                        >Next</ur-button
                      >
                    </div>
                  </div>
                </div>
              </div>
              <!---->

              <ur-notification-badge
                class="notification-inner-block"
                dot
                overlap
              >
                <ur-icon-button
                  icon="notification"
                  icon-type="line"
                  color="default"
                  id="notification"
                  iconSize="18"
                  class="mx-1"
                  >Notification</ur-icon-button
                >
              </ur-notification-badge>

              <div class="dropdown">
                <svg
                  data-v-73da1b8a=""
                  id="setting"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="26"
                >
                  <circle
                    data-v-73da1b8a=""
                    cx="12"
                    cy="10"
                    r="3"
                    fill="#454ca5"
                  ></circle>
                  <circle
                    data-v-73da1b8a=""
                    cx="12"
                    cy="12"
                    r="9"
                    stroke="#454ca5"
                    stroke-width="1"
                  ></circle>
                  <path
                    data-v-73da1b8a=""
                    d="M17.8719 18.8083C17.9489 18.7468 17.9799 18.6436 17.9452 18.5513C17.5693 17.5518 16.8134 16.6706 15.7814 16.0332C14.6966 15.3632 13.3674 15 12 15C10.6326 15 9.30341 15.3632 8.21858 16.0332C7.18663 16.6706 6.43066 17.5518 6.05477 18.5513C6.02009 18.6436 6.05115 18.7468 6.12813 18.8083C9.56196 21.552 14.438 21.552 17.8719 18.8083Z"
                    fill="#989ee6"
                    fill-opacity="0.24"
                    stroke="#454ca5"
                    stroke-width="1"
                    stroke-linecap="round"
                  ></path>
                </svg>
                <div class="dropdown-content">
                  <ur-button class="nav-bottom-hover">
                    <div class="user-name-email">
                      <ur-icon-button
                        icon-type="line"
                        color="default"
                        iconSize="18"
                        class="mx-1"
                        icon="unlock"
                      />
                    </div>
                    Change Password
                  </ur-button>
                  <ur-button class="nav-bottom-hover" @click="logOut">
                    <ur-icon-button
                      icon="sign_out"
                      icon-type="line"
                      color="default"
                      iconSize="18"
                      class="mx-1"
                    ></ur-icon-button>
                    Logout</ur-button
                  >
                </div>
              </div>
            </span>
          </span>

          <span class="for-mobile vertical-menus">
            <ur-button class="nav-bottom-hover">
              <ur-icon-button
                icon="help"
                icon-type="line"
                color="default"
                id="help"
                v-ur-tooltip="'Help'"
                iconSize="18"
                class="mx-1"
              ></ur-icon-button>
              Help
            </ur-button>
            <ur-button class="nav-bottom-hover">
              <ur-notification-badge
                class="notification-inner-block"
                dot
                overlap
              >
                <ur-icon-button
                  icon="notification"
                  icon-type="line"
                  color="default"
                  id="notification"
                  iconSize="18"
                  class="mx-1"
                ></ur-icon-button> </ur-notification-badge
              >Notification
            </ur-button>
            <ur-button class="nav-bottom-hover">
              <div class="user-name-email">
                <ur-icon-button
                  icon-type="line"
                  color="default"
                  iconSize="18"
                  class="mx-1"
                  icon="unlock"
                />
              </div>
              Change Password
            </ur-button>
            <ur-button class="nav-bottom-hover" @click="logOut">
              <ur-icon-button
                icon="sign_out"
                icon-type="line"
                color="default"
                iconSize="18"
                class="mx-1"
              ></ur-icon-button>
              Logout</ur-button
            >
          </span>
        </div>
      </template>
    </ur-gnb>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import AuthService from "../../services/AuthService";
import { IMS_MODULE_ID } from "@/constants/constants";

export default {
  name: "Header",
  data() {
    return {
      businessUnitData: [],
      selectedBusinessUnit: {},
      top_menu: [],
    };
  },
  computed: {
    ...mapGetters(["getUserInfo"]),
    getSelectedMenu() {
      return this.top_menu.findIndex((menu) => menu.name === "IMS");
    },
  },
  created() {
    this.selectedBusinessUnit = localStorage.getItem("bizUnit");
    this.getHeaderMenuAction()
      .then((resp) => {
        resp.data.forEach((menu) => {
          this.top_menu.push({
            text: menu.moduleDescription,
            value: menu.moduleId,
            name: menu.moduleName,
            url: `/${menu.moduleId}`,
            displayYn: "Y",
            hasChild: false,
            children: [],
          });
        });
        if (this.top_menu.find((menu) => menu.value === IMS_MODULE_ID))
          this.getBizUnitListingAction()
            .then((resp) => {
              resp.data.forEach((element) => {
                this.businessUnitData.push({
                  value: element.name,
                  text: element.name,
                  ...element,
                });
              });
              if (
                localStorage.getItem("bizUnit") === null ||
                localStorage.getItem("bizUnit") == "undefined"
              ) {
                localStorage.setItem("bizUnit", resp.data[0].name);
                this.selectedBusinessUnit = resp.data[0].name;
              }
            })
            .catch((err) => {});
        else this.logOut();
      })
      .catch((err) => {});
  },
  mounted() {
    // Close the dropdown if the user clicks outside of it
    window.onclick = function (e) {
      if (!e.target.matches(".dropbtn")) {
        var myDropdown = document.getElementById("myDropdown");
        if (myDropdown && myDropdown.classList.contains("show")) {
          myDropdown.classList.remove("show");
        }
      }
    };

    // var openHelp = document.getElementById("open-help");
    // var closeHelp = document.getElementById("close-help");
    // var overlayHelp = document.getElementById("overlay-Help");

    // window.addEventListener("keydown", (e) => {
    //   if (e.altKey && (e.key == "h" || e.key == "H")) {
    //     this.currentTab = 0;
    //     document.getElementById("sidebarMenu").classList.toggle("openHelp");
    //     overlayHelp.classList.toggle("overlayHelp");
    //   }
    // });

    // openHelp.addEventListener("click", () => {
    //   document.getElementById("sidebarMenu").classList.toggle("openHelp");
    //   overlayHelp.classList.toggle("overlayHelp");
    // });

    // closeHelp.addEventListener("click", () => {
    //   document.getElementById("sidebarMenu").classList.toggle("openHelp");
    //   overlayHelp.classList.toggle("overlayHelp");
    // });

    // var burgerMenu = document.getElementById("burger-menu2");

    // burgerMenu.addEventListener("click", function () {
    //   this.classList.toggle("close");
    //   document.getElementById("forSettingMenu").classList.toggle("overlay2");
    // });
  },
  methods: {
    ...mapActions([
      "getBizUnitListingAction",
      "getUserMenu",
      "getHeaderMenuAction",
      "DMSLogOutAction",
    ]),
    inputBizUnit(sel) {
      localStorage.setItem("bizUnit", sel);
      window.location.reload();
    },
    go_home() {
      console.log("here is go_home");
    },
    move(url) {
      console.log("here is move >> url : " + url);
    },
    logOut() {
      let tokenIndex = localStorage.getItem("token").indexOf(" ");
      const payload = {
        token: localStorage.getItem("token").substring(tokenIndex + 1),
        username: this.getUserInfo.userCd,
      };
      this.DMSLogOutAction(payload)
        .then((res) => {
          AuthService.doLogout();
        })
        .catch((err) => {});
    },
    showDropdown() {
      document.getElementById("myDropdown").classList.toggle("show");
    },
  },
};
</script>

<style scoped>
.ur-gnb.gnb-showcase {
  position: relative;
}

.custom-title {
  /* color: $ur__color--primary; */
  font-weight: bold;
  cursor: pointer;
}

.ur-gnb__search-text-field {
  margin-right: 50px;
}

.ur-gnb__search-text-field .ur-text-field__input {
  width: 100%;
  padding: 0 5px 0 10px;
  font-size: 12px;
  border-style: solid;
  outline: none;
  border-color: transparent;
  background-color: #f0f0f0;
  border-radius: 5px;
}

.dropdown {
  position: relative;
  display: inline-block;
}
.dropdown #setting {
  margin-top: 1px;
  cursor: pointer;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: #f9f9f9;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
  right: 0;
}

.dropdown-content a {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
  text-align: left;
}

.dropdown-content a:hover {
  background-color: #ddd;
}

.dropdown:hover .dropdown-content {
  display: block;
}

.nav-bottom-hover {
  width: 100%;
  padding-left: 0 !important;
  justify-content: flex-start;
  margin: 0;
  align-items: center;
  font-size: 12px;
}

.for-mobile {
  display: none;
}

.for-desktop {
  display: block;
}

@media only screen and (min-width: 280px) and (max-width: 912px) {
  .for-mobile {
    display: inline-block;
    width: 25px;
    position: relative;
    left: 0px;
    padding: 6px;
  }

  .for-desktop {
    display: none;
  }
}

#sidebarMenu {
  height: 100%;
  position: fixed;
  right: -650px;
  width: 650px;
  margin-top: 0;
  top: 0;
  transform: translateX(-650px);
  transition: transform 650ms ease-in-out;
  background: rgb(255, 255, 255);
  z-index: 9999999;
  box-shadow: -2px 2px 8px rgb(0 0 0 / 26%);
}

.sidebarIconToggle {
  transition: all 0.3s;
  box-sizing: border-box;
  cursor: pointer;
  position: absolute;
  z-index: 99;
  height: 100%;
  width: 100%;
  top: 0;
  left: 15px;
  height: 22px;
  width: 22px;
  z-index: 9999;
}

.openHelp {
  transform: translateX(0) !important;
}

.overlayHelp {
  background: rgb(0 0 0 / 33%);
  height: 100%;
  position: fixed;
  left: 0;
  width: 100%;
  margin-top: 0;
  top: 0;
}
.help-modal-header,
.help-modal-footer {
  display: flex;
  justify-content: space-between;
  padding: 15px;
  border-bottom: 1px solid #cfcfcf;
}
.help-modal-header > .heading h4 {
  font-size: 16px;
}
.help-modal-header > .heading span {
  font-size: 14px;
}
.actn-cmmn-btn,
.actn-nxt-btn {
  border-radius: 2px !important;
  font-size: 12px;
}
.actn-nxt-btn {
  color: #ffffff !important;
  font-weight: 500 !important;
  background-color: var(--ur__color--primary) !important;
}
.actn-cmmn-btn {
  color: #2a2a2a !important;
  font-weight: 500 !important;
  background-color: #f5f5f5 !important;
}
.help-modal-body {
  position: relative;
  height: calc(100vh - 160px);
  overflow-x: hidden;
  overflow-y: auto;
  padding: 15px;
}
.help-modal-footer {
  position: fixed;
  width: 100%;
  bottom: 0;
  border: 0;
  box-shadow: 2px -2px 6px rgb(0 0 0 / 12%);
}
.help-modal h4,
.help-modal p {
  margin: 0px;
  padding: 0px;
  color: #2a2a2a;
}
.help-modal h4 {
  font-size: 16px;
  margin-bottom: 5px;
}
.help-modal p,
.help-modal ul li {
  font-size: 14px;
  line-height: 2rem;
}
.help-modal .ol-main-tree {
  padding-left: 14px;
}
.help-modal ol > li {
  list-style: decimal;
  margin-bottom: 5px;
}
.help-modal ul > li {
  list-style: outside;
  margin-bottom: 5px;
}
.help-modal .ol-main-tree li::marker {
  font-weight: 600;
  font-size: 14px;
}
.help-modal a {
  color: var(--ur__color--primary) !important;
  text-decoration: none;
}
.text-tips {
  color: darkgoldenrod;
}
.list-img img {
  width: 100%;
}
.text-note {
  color: #454ca5 !important;
  font-weight: bold;
}
#close-help {
  width: 28px !important;
  height: 28px;
  border-radius: 100px;
}
</style>
